(() => {
  'use strict';

  const root = (window.MovingRoom && window.MovingRoom.root) || '/';
  const allProducts = (window.MovingRoom && window.MovingRoom.allProducts) || `${root}collections/all`;
  const moneyFormat = (window.MovingRoom && window.MovingRoom.moneyFormat) || '${{amount}}';
  const currencyCode = (window.MovingRoom && window.MovingRoom.currencyCode) || '';
  const showCurrencyCode = Boolean(window.MovingRoom && window.MovingRoom.showCurrencyCode);
  const freeShippingThreshold = Number(window.MovingRoom && window.MovingRoom.freeShippingThreshold) || 0;
  const animations = !window.MovingRoom || window.MovingRoom.animations !== false;
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const lock = () => document.body.classList.add('is-locked');
  const unlock = () => {
    if (!$('[data-cart-drawer]:not([hidden]),[data-search-panel]:not([hidden]),[data-mobile-nav]:not([hidden]),[data-filter-drawer]:not([hidden]),[data-measure-drawer]:not([hidden])')) document.body.classList.remove('is-locked');
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const formatMoney = (cents, format = moneyFormat) => {
    const value = Number(cents || 0);
    const tokenMatch = String(format).match(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator|_with_apostrophe_separator)?)\s*\}\}/);
    if (!tokenMatch) return `$${(value / 100).toFixed(2)}${showCurrencyCode && currencyCode ? ` ${currencyCode}` : ''}`;
    const token = tokenMatch[1];
    const decimals = token.includes('no_decimals') ? 0 : 2;
    const decimalMark = token.includes('comma_separator') ? ',' : '.';
    const thousandsMark = token.includes('comma_separator') ? '.' : token.includes('apostrophe') ? "'" : ',';
    const parts = (value / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
    const formatted = decimals ? `${parts[0]}${decimalMark}${parts[1]}` : parts[0];
    const output = String(format).replace(tokenMatch[0], formatted);
    return `${output}${showCurrencyCode && currencyCode ? ` ${currencyCode}` : ''}`;
  };
  const imageSized = (src, width = 240) => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_) { return src; }
  };
  const toast = message => {
    const node = $('[data-mr-toast]');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    clearTimeout(node._timer);
    node._timer = setTimeout(() => node.classList.remove('is-visible'), 2600);
  };

  let layerOpener = null;
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const openLayer = node => {
    if (!node) return;
    layerOpener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    node.hidden = false;
    lock();
    requestAnimationFrame(() => $(focusableSelector, node)?.focus());
  };
  const closeLayer = node => {
    if (!node || node.hidden) return;
    node.hidden = true;
    unlock();
    if (layerOpener?.isConnected) layerOpener.focus();
    layerOpener = null;
  };
  const trapLayerFocus = event => {
    if (event.key !== 'Tab') return;
    const layers = $$('[data-cart-drawer]:not([hidden]),[data-search-panel]:not([hidden]),[data-mobile-nav]:not([hidden]),[data-filter-drawer]:not([hidden]),[data-measure-drawer]:not([hidden])');
    const layer = layers.at(-1);
    if (!layer) return;
    const focusable = $$(focusableSelector, layer).filter(node => node.getAttribute('aria-hidden') !== 'true');
    if (!focusable.length) return;
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && (document.activeElement === first || !layer.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !layer.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  };

  function initHeader(scope = document) {
    const header = scope.matches?.('[data-mr-header]') ? scope : $('[data-mr-header]', scope);
    if (!header || header.dataset.mrReady) return;
    header.dataset.mrReady = 'true';
    const mobile = $('[data-mobile-nav]', header);
    $$('[data-mobile-nav-open]', scope).forEach(btn => btn.addEventListener('click', () => openLayer(mobile)));
    $$('[data-mobile-nav-close]', mobile || scope).forEach(btn => btn.addEventListener('click', () => closeLayer(mobile)));
    const search = $('[data-search-panel]', header);
    $$('[data-search-open]', scope).forEach(btn => btn.addEventListener('click', event => { if (!search) return; event.preventDefault(); openLayer(search); setTimeout(() => $('input[type="search"]', search)?.focus(), 80); }));
    $$('[data-search-close]', search || scope).forEach(btn => btn.addEventListener('click', () => closeLayer(search)));
  }

  let cartMutating = false;
  async function getCart() {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }
  function updateCartCount(count) { $$('[data-cart-count]').forEach(node => { node.textContent = count; }); }
  function renderCart(cart) {
    const body = $('[data-cart-drawer-body]');
    const foot = $('[data-cart-drawer-foot]');
    if (!body || !foot) return;
    updateCartCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = `<div class="mr-empty-state"><span class="mr-kicker">AN OPEN FLOOR</span><h2>Your room is empty.</h2><p>Begin with one useful movement object.</p><a class="mr-button mr-button--ink" href="${escapeHtml(allProducts)}">Explore objects</a></div>`;
      foot.hidden = true;
    } else {
      body.innerHTML = cart.items.map((item, index) => `<article class="mr-mini-line" data-line="${index + 1}">
        <a href="${escapeHtml(item.url)}"><img src="${escapeHtml(imageSized(item.featured_image?.url || item.image, 240))}" width="120" height="120" alt="${escapeHtml(item.product_title)}"></a>
        <div><span class="mr-kicker">${escapeHtml(item.product_type || item.vendor || 'Movement object')}</span><h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>${item.variant_title ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}<div class="mr-mini-line__qty"><button type="button" data-cart-change="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}">+</button></div><button type="button" data-cart-change="${index + 1}" data-quantity="0">Remove</button></div>
        <strong>${item.original_line_price !== item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s><br>` : ''}${formatMoney(item.final_line_price)}</strong>
      </article>`).join('');
      $('[data-cart-total]').textContent = formatMoney(cart.total_price);
      const discounts = $('[data-cart-discounts]');
      if (discounts) {
        const applications = cart.cart_level_discount_applications || [];
        discounts.hidden = applications.length === 0;
        discounts.innerHTML = applications.map(discount => `<div><span>${escapeHtml(discount.title)}</span><strong>−${formatMoney(discount.total_allocated_amount)}</strong></div>`).join('');
      }
      foot.hidden = false;
      $$('[data-cart-change]', body).forEach(btn => btn.addEventListener('click', () => changeCart(Number(btn.dataset.cartChange), Number(btn.dataset.quantity))));
    }
    const freeThreshold = freeShippingThreshold;
    const remaining = Math.max(0, freeThreshold - cart.total_price);
    const progress = $('[data-cart-progress]');
    if (progress) {
      progress.hidden = freeThreshold <= 0;
      progress.style.setProperty('--progress', `${freeThreshold > 0 ? Math.min(100, (cart.total_price / freeThreshold) * 100) : 0}%`);
      const copy = $('[data-cart-progress-copy]', progress);
      if (copy && freeThreshold > 0) copy.textContent = remaining ? `${formatMoney(remaining)} from the complimentary-shipping threshold.` : 'Complimentary-shipping threshold reached.';
    }
    const note = $('[data-cart-note]');
    if (note && document.activeElement !== note) note.value = cart.note || '';
  }
  async function refreshCart(open = false) {
    try {
      const cart = await getCart();
      renderCart(cart);
      if (open) openLayer($('[data-cart-drawer]'));
    } catch (error) { toast(error.message); }
  }
  async function changeCart(line, quantity) {
    if (cartMutating) return;
    cartMutating = true;
    $$('[data-cart-change]', $('[data-cart-drawer-body]') || document).forEach(button => { button.disabled = true; });
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!response.ok) throw new Error('The bag could not be updated.');
      renderCart(await response.json());
    } catch (error) {
      toast(error.message);
      $$('[data-cart-change]', $('[data-cart-drawer-body]') || document).forEach(button => { button.disabled = false; });
    } finally {
      cartMutating = false;
    }
  }
  async function saveCartNote(button) {
    const note = $('[data-cart-note]');
    const status = $('[data-cart-note-status]');
    if (!note || !button) return;
    button.disabled = true;
    if (status) status.textContent = 'Saving…';
    try {
      const response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) });
      if (!response.ok) throw new Error('The order note could not be saved.');
      renderCart(await response.json());
      if (status) status.textContent = 'Order note saved.';
    } catch (error) {
      if (status) status.textContent = error.message;
      toast(error.message);
    } finally {
      button.disabled = false;
    }
  }
  function initCart(scope = document) {
    const drawer = $('[data-cart-drawer]');
    $$('[data-cart-open]', scope).forEach(button => {
      if (button.dataset.mrReady) return;
      button.dataset.mrReady = 'true';
      button.addEventListener('click', event => { if (!drawer) return; event.preventDefault(); refreshCart(true); });
    });
    if (!drawer || drawer.dataset.mrReady) return;
    drawer.dataset.mrReady = 'true';
    $$('[data-drawer-close]', drawer || scope).forEach(btn => btn.addEventListener('click', () => closeLayer(drawer)));
    const noteSave = $('[data-cart-note-save]', drawer);
    noteSave?.addEventListener('click', () => saveCartNote(noteSave));
    if (drawer) refreshCart(false);
  }

  function initPortal(scope = document) {
    $$('[data-scene-portal]', scope).forEach(portal => {
      const switches = $$('[data-portal-switch]', portal);
      const object = $('[data-portal-object]', portal);
      const objectImage = $('.mr-portal__object-image', object);
      const sceneImage = $('[data-portal-scene] img', portal);
      const title = $('[data-portal-title]', portal), series = $('[data-portal-series]', portal), index = $('[data-portal-index]', portal), link = $('[data-portal-primary]', portal);
      switches.forEach((button, buttonIndex) => button.addEventListener('click', () => {
        switches.forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-selected', item === button ? 'true' : 'false'); });
        object?.classList.add('is-changing');
        if (sceneImage) sceneImage.style.opacity = '0';
        setTimeout(() => {
          if (objectImage) { objectImage.src = button.dataset.image; objectImage.srcset = ''; objectImage.alt = button.dataset.title || ''; }
          if (sceneImage) { sceneImage.src = button.dataset.scene; sceneImage.srcset = ''; sceneImage.alt = `${button.dataset.title || 'Product'} in a room`; sceneImage.style.opacity = ''; }
          if (title) title.textContent = button.dataset.title;
          if (series) series.textContent = button.dataset.series;
          if (index) index.textContent = String(buttonIndex + 1).padStart(2, '0');
          if (link) link.href = button.dataset.url;
          object?.classList.remove('is-changing');
        }, 230);
      }));
    });
  }

  function initRibbonMap(scope = document) {
    $$('[data-ribbon-map]', scope).forEach(map => {
      const items = $$('[data-ribbon-item]', map), scene = $('[data-ribbon-scene]', map), sceneWrap = $('.mr-ribbon-map__scene', map);
      const number = $('[data-ribbon-number]', map), title = $('[data-ribbon-title]', map), zone = $('[data-ribbon-zone]', map), note = $('[data-ribbon-note]', map), link = $('[data-ribbon-link]', map);
      const activate = item => {
        if (!item || item.classList.contains('is-active')) return;
        items.forEach(row => row.classList.toggle('is-active', row === item));
        sceneWrap?.classList.add('is-changing');
        setTimeout(() => {
          if (scene) { scene.src = item.dataset.scene; scene.alt = `${item.dataset.title} movement scene`; }
          if (number) number.textContent = item.dataset.number;
          if (title) title.textContent = item.dataset.title;
          if (zone) zone.textContent = item.dataset.zone;
          if (note) note.textContent = item.dataset.note;
          if (link) link.href = item.href;
          sceneWrap?.classList.remove('is-changing');
        }, 220);
      };
      items.forEach(item => { item.addEventListener('mouseenter', () => activate(item)); item.addEventListener('focus', () => activate(item)); });
    });
  }

  function initComposer(scope = document) {
    $$('[data-routine-composer]', scope).forEach(composer => {
      const items = $$('[data-composer-item]', composer);
      if (!items.length) return;
      const form = $('[data-composer-form]', composer), time = $('[data-composer-time]', composer), matchesWrap = $('[data-composer-matches]', composer);
      const image = $('[data-composer-image]', composer), title = $('[data-composer-title]', composer), copy = $('[data-composer-copy]', composer), route = $('[data-composer-route]', composer), link = $('[data-composer-link]', composer), count = $('[data-composer-count]', composer);
      const dataOf = item => ({ item, focus: item.dataset.focus, space: item.dataset.space, time: Number(item.dataset.time), title: item.dataset.title, copy: item.dataset.copy, image: item.dataset.image, url: item.dataset.url });
      const show = data => { if (image) { image.src = data.image; image.alt = data.title; } if (title) title.textContent = data.title; if (copy) copy.textContent = data.copy; if (route) route.textContent = `${data.focus} / ${data.space}`; if (link) link.href = data.url; };
      const update = () => {
        const focus = $('input[name="focus"]:checked', form)?.value || 'strength';
        const space = $('input[name="space"]:checked', form)?.value || 'floor';
        const timeValue = Number(time?.value || 2);
        const ranked = items.map(dataOf).map(data => ({ ...data, score: (data.focus === focus ? 5 : 0) + (data.space === space ? 4 : 0) + (data.time <= timeValue ? 2 : Math.max(0, 2 - (data.time - timeValue))) })).sort((a, b) => b.score - a.score);
        const matchCount = timeValue === 1 ? 1 : timeValue === 2 ? 2 : 3;
        const matches = ranked.slice(0, matchCount);
        show(matches[0]);
        if (count) count.textContent = `${matches.length} matched object${matches.length === 1 ? '' : 's'} / ${timeValue === 1 ? '10 min' : timeValue === 2 ? '20 min' : '30+ min'}`;
        if (matchesWrap) {
          matchesWrap.innerHTML = matches.map((data, index) => `<button type="button" class="mr-composer-match${index === 0 ? ' is-active' : ''}" data-match-index="${index}"><img src="${escapeHtml(data.image)}" width="60" height="60" alt=""><strong>${escapeHtml(data.title)}</strong></button>`).join('');
          $$('[data-match-index]', matchesWrap).forEach(button => button.addEventListener('click', () => { const selected = matches[Number(button.dataset.matchIndex)]; show(selected); $$('[data-match-index]', matchesWrap).forEach(b => b.classList.toggle('is-active', b === button)); }));
        }
      };
      form?.addEventListener('change', update); time?.addEventListener('input', update); update();
    });
  }

  function initMechanism(scope = document) {
    $$('[data-mechanism-stage]', scope).forEach(stage => {
      const tabs = $$('[data-mechanism-tab]', stage), panels = $$('[data-mechanism-panel]', stage);
      tabs.forEach(tab => tab.addEventListener('click', () => {
        tabs.forEach(item => { item.classList.toggle('is-active', item === tab); item.setAttribute('aria-selected', item === tab ? 'true' : 'false'); });
        panels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.mechanismPanel === tab.dataset.mechanismTab));
      }));
    });
  }

  function initChoreography(scope = document) {
    $$('[data-choreography]', scope).forEach(section => {
      const track = $('[data-choreo-track]', section), scenes = $$('.mr-choreo-scene', section), progress = $('[data-choreo-progress]', section);
      if (!track || !scenes.length) return;
      const move = direction => track.scrollBy({ left: direction * Math.min(track.clientWidth * .82, 900), behavior: 'smooth' });
      $('[data-choreo-prev]', section)?.addEventListener('click', () => move(-1)); $('[data-choreo-next]', section)?.addEventListener('click', () => move(1));
      const update = () => { const max = Math.max(1, track.scrollWidth - track.clientWidth); const ratio = track.scrollLeft / max; progress?.parentElement?.style.setProperty('--progress-x', `${ratio * 300}%`); if (progress) progress.style.width = `${Math.max(18, 100 / scenes.length)}%`; };
      track.addEventListener('scroll', update, { passive: true }); update();
    });
  }

  function initPlanner(scope = document) {
    $$('[data-space-planner]', scope).forEach(planner => {
      const select = $('[data-planner-select]', planner), range = $('[data-planner-range]', planner), items = $$('[data-planner-item]', planner);
      if (!select || !range || !items.length) return;
      const getItem = () => items.find(item => item.dataset.id === select.value) || items[0];
      const update = () => {
        const item = getItem(), feet = Number(range.value), roomInches = feet * 12, width = Number(item.dataset.width), ratio = Math.min(82, Math.max(18, (width / roomInches) * 86));
        const object = $('[data-planner-object]', planner), image = $('[data-planner-image]', planner), title = $('[data-planner-title]', planner), footprint = $('[data-planner-footprint]', planner), feetNode = $('[data-planner-feet]', planner), roomLabel = $('[data-planner-room-label]', planner), status = $('[data-planner-status]', planner), message = $('[data-planner-message]', planner), link = $('[data-planner-link]', planner);
        object?.style.setProperty('--object-width', `${ratio}%`); if (image) { image.src = item.dataset.image; image.alt = item.dataset.title; } if (title) title.textContent = item.dataset.title; if (footprint) footprint.textContent = item.dataset.footprint; if (feetNode) feetNode.textContent = feet.toFixed(feet % 1 ? 1 : 0); if (roomLabel) roomLabel.textContent = `${feet} ft available`; if (link) link.href = item.dataset.url;
        const clearance = roomInches - width;
        if (status && message) { if (clearance >= 36) { status.textContent = 'COMFORTABLE FIT'; message.textContent = `About ${Math.round(clearance)} inches remain across the selected width.`; } else if (clearance >= 18) { status.textContent = 'CLOSE FIT'; message.textContent = `About ${Math.round(clearance)} inches remain. Confirm the movement clearance in every direction.`; } else { status.textContent = 'MORE SPACE NEEDED'; message.textContent = 'Choose a wider clear area before using this object.'; } }
      };
      select.addEventListener('change', update); range.addEventListener('input', update); update();
    });
  }

  function initProductCards(scope = document) {
    $$('[data-mr-object-card],[data-r31-object-card]', scope).forEach(card => {
      if (card.dataset.mrCardReady) return;
      card.dataset.mrCardReady = 'true';
      const visual = $('.mr-object-card__visual,.r31-object-card__visual', card);
      if (!visual || !$('.mr-object-card__image--measure,.r31-object-card__image--measure', visual)) return;
      let timer, held = false;
      visual.addEventListener('pointerdown', event => {
        held = false;
        if (event.pointerType !== 'mouse') timer = setTimeout(() => { held = true; visual.classList.add('is-measuring'); }, 380);
      });
      visual.addEventListener('click', event => { if (held) { event.preventDefault(); held = false; } });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(name => visual.addEventListener(name, () => { clearTimeout(timer); if (name !== 'pointerleave') setTimeout(() => visual.classList.remove('is-measuring'), 900); }));
    });
  }

  function activateGalleryMedia(rootNode, mediaId) {
    const media = $(`[data-gallery-media="${CSS.escape(String(mediaId))}"]`, rootNode); if (!media) return;
    $$('[data-gallery-media]', rootNode).forEach(item => item.classList.toggle('is-active', item === media));
    $$('[data-gallery-thumb]', rootNode).forEach(item => { const active = item.dataset.galleryThumb === String(mediaId); item.classList.toggle('is-active', active); item.setAttribute('aria-selected', active ? 'true' : 'false'); });
    if (window.innerWidth >= 990) media.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function initProduct(scope = document) {
    $$('[data-product-root]', scope).forEach(productRoot => {
      if (productRoot.dataset.mrReady) return;
      productRoot.dataset.mrReady = 'true';
      const galleryThumbs = $$('[data-gallery-thumb]', productRoot);
      galleryThumbs.forEach((button, index) => {
        button.addEventListener('click', () => activateGalleryMedia(productRoot, button.dataset.galleryThumb));
        button.addEventListener('keydown', event => {
          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % galleryThumbs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + galleryThumbs.length) % galleryThumbs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = galleryThumbs.length - 1;
          else return;
          event.preventDefault();
          galleryThumbs[nextIndex].focus();
          galleryThumbs[nextIndex].click();
        });
      });
      const variantsNode = $('[data-product-variants]', productRoot); let variants = [];
      try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) { variants = []; }
      let inventoryRecords = [];
      try { inventoryRecords = JSON.parse($('[data-variant-inventory-data]', productRoot)?.textContent || '[]'); } catch (_) { inventoryRecords = []; }
      const inventoryById = new Map(inventoryRecords.map(record => [String(record.id), record]));
      const hiddenId = $('[data-variant-id]', productRoot);
      const add = $('[data-add-to-cart]', productRoot);
      const addLabel = $('[data-add-label]', productRoot);
      const mobileAdd = $('[data-mobile-add]', productRoot);
      const priceWrap = $('[data-price-wrap]', productRoot);
      const price = $('[data-product-price]', productRoot);
      const compare = $('[data-compare-price]', productRoot);
      const mobilePrice = $('[data-mobile-price]', productRoot);
      const productMessage = $('[data-product-message]', productRoot);
      const sku = $('[data-variant-sku]', productRoot);
      const inventory = $('[data-variant-inventory]', productRoot);
      let currentVariant = null;
      const renderInventory = variant => {
        if (!inventory || !variant) return;
        const record = inventoryById.get(String(variant.id)) || {};
        const quantity = Number(record.quantity ?? variant.inventory_quantity ?? 0);
        const management = record.management ?? variant.inventory_management;
        const policy = record.policy ?? variant.inventory_policy;
        const threshold = Number(inventory.dataset.lowStockThreshold || 0);
        const showCount = inventory.dataset.showCount === 'true';
        let state = 'available';
        let label = inventory.dataset.availableText || 'In stock and ready to order';
        if (!variant.available) {
          state = 'sold-out';
          label = inventory.dataset.soldOutText || 'Sold out';
        } else if (management && quantity <= 0 && policy === 'continue') {
          state = 'continue';
          label = inventory.dataset.continueText || 'Available to order';
        } else if (management && quantity <= threshold) {
          state = 'low';
          label = showCount && quantity > 0 ? `Only ${quantity} left in stock` : (inventory.dataset.lowStockText || 'Low stock');
        }
        inventory.classList.remove('is-available', 'is-low', 'is-continue', 'is-sold-out');
        inventory.classList.add(`is-${state}`);
        const labelNode = $('[data-inventory-label]', inventory);
        if (labelNode) labelNode.textContent = label;
      };
      const updateVariant = (updateUrl = true) => {
        const values = $$('[data-option-index]', productRoot).map(fieldset => $('input:checked', fieldset)?.value);
        const variant = values.length ? variants.find(item => item.options.every((option, index) => option === values[index])) : variants.find(item => String(item.id) === String(hiddenId?.value)) || variants[0];
        $$('[data-option-index]', productRoot).forEach((fieldset, optionIndex) => {
          $$('input', fieldset).forEach(input => {
            const candidate = values.slice();
            candidate[optionIndex] = input.value;
            const possible = variants.some(item => item.available && item.options.every((option, index) => !candidate[index] || option === candidate[index]));
            // Keep every existing option selectable so another valid combination can be reached.
            input.disabled = !variants.some(item => item.options[optionIndex] === input.value);
            input.parentElement?.classList.toggle('is-unavailable', !possible);
          });
        });
        currentVariant = variant || null;
        if (!variant) { if (add) add.disabled = true; if (addLabel) addLabel.textContent = 'Unavailable'; if (mobileAdd) { mobileAdd.disabled = true; mobileAdd.textContent = 'Unavailable'; } return null; }
        if (hiddenId) hiddenId.value = variant.id; if (price) price.textContent = formatMoney(variant.price); if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price); if (sku) sku.textContent = variant.sku || '';
        const onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        priceWrap?.classList.toggle('mr-price--sale', onSale);
        if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
        const available = Boolean(variant.available); if (add) add.disabled = !available; if (addLabel) addLabel.textContent = available ? 'Add to bag' : 'Sold out'; if (mobileAdd) { mobileAdd.disabled = !available; mobileAdd.textContent = available ? 'Add to bag' : 'Sold out'; }
        renderInventory(variant);
        if (variant.featured_media?.id) activateGalleryMedia(productRoot, variant.featured_media.id);
        if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url.toString()); }
        return variant;
      };
      $$('[data-option-index] input', productRoot).forEach(input => input.addEventListener('change', updateVariant));
      mobileAdd?.addEventListener('click', () => add?.click());
      const form = $('[data-product-form]', productRoot);
      if (form && $('[data-cart-drawer]')) form.addEventListener('submit', async event => {
        event.preventDefault(); if (!add || add.disabled) return; add.disabled = true; if (addLabel) addLabel.textContent = 'Adding…';
        if (productMessage) productMessage.textContent = '';
        try { const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) }); const payload = await response.json(); if (!response.ok) throw new Error(payload.description || 'This object could not be added.'); toast('Added to your moving room.'); if (productMessage) productMessage.textContent = 'Added to bag.'; await refreshCart(true); }
        catch (error) { toast(error.message); if (productMessage) productMessage.textContent = error.message; }
        finally { if (currentVariant) { const available = Boolean(currentVariant.available); add.disabled = !available; if (addLabel) addLabel.textContent = available ? 'Add to bag' : 'Sold out'; } else { updateVariant(false); } }
      });
      updateVariant(false);
    });
  }

  function initQuantities(scope = document) {
    $$('[data-qty-minus]', scope).forEach(button => { if (button.dataset.mrReady) return; button.dataset.mrReady = 'true'; button.addEventListener('click', () => { const input = button.parentElement?.querySelector('input[type="number"]'); if (input) { input.value = Math.max(Number(input.min || 0), Number(input.value || 0) - Number(input.step || 1)); input.dispatchEvent(new Event('change', { bubbles: true })); } }); });
    $$('[data-qty-plus]', scope).forEach(button => { if (button.dataset.mrReady) return; button.dataset.mrReady = 'true'; button.addEventListener('click', () => { const input = button.parentElement?.querySelector('input[type="number"]'); if (input) { const next = Number(input.value || 0) + Number(input.step || 1); input.value = input.max ? Math.min(Number(input.max), next) : next; input.dispatchEvent(new Event('change', { bubbles: true })); } }); });
  }
  function initDrawers(scope = document) {
    const measure = $('[data-measure-drawer]', scope); $$('[data-measure-open]', scope).forEach(button => button.addEventListener('click', () => openLayer(measure))); $$('[data-measure-close]', measure || scope).forEach(button => button.addEventListener('click', () => closeLayer(measure)));
    const filter = $('[data-filter-drawer]', scope); $$('[data-filter-open]', scope).forEach(button => button.addEventListener('click', () => openLayer(filter))); $$('[data-filter-close]', filter || scope).forEach(button => button.addEventListener('click', () => closeLayer(filter)));
  }
  function initZoom(scope = document) {
    const dialog = $('[data-mr-zoom]'); const image = $('[data-zoom-image]', dialog || document);
    $$('[data-zoom-src]', scope).forEach(button => button.addEventListener('click', () => { if (!dialog || !image) return; image.src = button.dataset.zoomSrc; image.alt = button.dataset.zoomAlt || ''; dialog.showModal(); lock(); }));
    if (!dialog || dialog.dataset.mrReady) return;
    dialog.dataset.mrReady = 'true';
    $('[data-zoom-close]', dialog || document)?.addEventListener('click', () => { dialog.close(); image?.removeAttribute('src'); unlock(); });
    dialog?.addEventListener('click', event => { if (event.target === dialog) { dialog.close(); image?.removeAttribute('src'); unlock(); } });
  }
  function initSort(scope = document) { $$('[data-sort-select]', scope).forEach(select => select.addEventListener('change', () => select.form?.submit())); }
  function initConfirm(scope = document) { $$('[data-confirm-message]', scope).forEach(button => button.addEventListener('click', event => { if (!window.confirm(button.dataset.confirmMessage)) event.preventDefault(); })); }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() { if (!this.dataset.url || this.dataset.loaded) return; this.dataset.loaded = 'true'; fetch(this.dataset.url).then(response => response.text()).then(text => { const html = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations'); if (html?.innerHTML.trim()) { this.innerHTML = html.innerHTML; initProductCards(this); this.dispatchEvent(new CustomEvent('room:content:loaded', { bubbles: true })); } }).catch(() => {}); }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  function initReveal(scope = document) {
    const nodes = $$('[data-reveal]', scope); if (!nodes.length || !('IntersectionObserver' in window)) return;
    if (!animations) { nodes.forEach(node => node.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); entry.target.classList.remove('is-pending'); observer.unobserve(entry.target); } }), { rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(node => { if (!node.classList.contains('is-visible')) { node.classList.add('is-pending'); observer.observe(node); } });
  }

  function init(scope = document) {
    initHeader(scope); initCart(scope); initProductCards(scope); initProduct(scope); initQuantities(scope); initDrawers(scope); initZoom(scope); initSort(scope); initConfirm(scope); initReveal(scope);
  }
  document.documentElement.classList.add('js');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', trapLayerFocus);
  document.addEventListener('keydown', event => { if (event.key !== 'Escape') return; ['[data-cart-drawer]','[data-search-panel]','[data-mobile-nav]','[data-filter-drawer]','[data-measure-drawer]'].forEach(selector => closeLayer($(selector))); const zoom = $('[data-mr-zoom]'); if (zoom?.open) { zoom.close(); unlock(); } });
})();
